import { ReactNode, useEffect, useState } from 'react';
import { Div, Flex } from '@gaiads/telia-react-component-library';
import Header from '../Header';
import { PageHeader } from '../PageHeader';
import { SideNavigation } from '../SideNavigation';
import styles from './WithNavigationLayout.module.scss';

interface WithNavigationLayoutProps {
  children: ReactNode;
}

const WithNavigationLayout = ({ children }: WithNavigationLayoutProps) => {
  const checkIsNotDesktop = () => {
    return window.innerWidth <= parseInt(styles.desktopBreakpoint, 10);
  };

  const [isNotDesktop, setIsNotDesktop] = useState(checkIsNotDesktop());

  useEffect(() => {
    function handleResize() {
      setIsNotDesktop(checkIsNotDesktop());
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <Div className={styles['top-level-header-container']}>
        <Header />
      </Div>
      <Div className={styles['top-level-layout-container']}>
        {isNotDesktop && <SideNavigation isNotDesktop />}
        <PageHeader />
        <Flex>
          {!isNotDesktop && (
            <Div className={styles['top-level-layout-container__side-navigation']}>
              <SideNavigation />
            </Div>
          )}
          <Div className={styles['top-level-layout-container__content']}>{children}</Div>
        </Flex>
      </Div>
    </>
  );
};

export default WithNavigationLayout;
